import type { FieldPolicy } from "@apollo/client"

export const customerCacheFields: Record<string, FieldPolicy> = {
  // No read redirect: Customer is cache-keyed by Id (ExternalCustomerId is
  // nullable since app-created customers exist), so an externalId arg can't
  // be resolved to a cache reference without a lookup table. The panel
  // query simply hits the network on first open.
  getCustomerByExternalId: {
    merge: false,
  },
}
